'use strict';

angular.module('atex.dam').directive('damZoom', function() {
  return {
	restrict: 'ACE',
    templateUrl : 'views/dam-zoom.html',
    replace:true,
    scope: {
      grid : "=",
      thumb : "=",
      physPage: "=",
      start : "=",
      min:"=",
      max:"=",
      fulls: "="
    },

    link: function (scope, element, attrs) {}
  };
});
